import { useLayoutEffect } from 'react'
import { v4 } from 'uuid'
import { useModelMeshStore } from '../state/store'

const useVerticalTransmitterVisibility = (visibleGuids: string[], stateId?: string) => {
  const add = useModelMeshStore(state => state.addVisibleVerticalTransmitterElementGuids)
  const remove = useModelMeshStore(state => state.removeVisibleVerticalTransmitterElementGuids)

  useLayoutEffect(() => {
    const uuid = stateId || v4()

    if (visibleGuids.length) {
      add(uuid, visibleGuids)
    }

    return () => remove(uuid)
  }, [add, remove, stateId, visibleGuids])
}

export default useVerticalTransmitterVisibility
